// Lagerbestands-Domaene (PRODSTOCK) - headless. Extrahiert aus
// CLS_CBonEntryOps.js acceptDelivery (Plan sharded-hatching-clover,
// Phase 3.3).
//
// Behebt dabei einen live bewiesenen Datenverfaelschungs-Bug des Originals:
// die var-Variablen der Positions-Schleife wurden von den async-SQL-Callbacks
// geteilt - bei einem Lieferschein mit MEHREREN Positionen verbuchten alle
// PRODSTOCK-Updates die Werte der LETZTEN Position (Testfall "Lieferschein:
// Bestandsfortschreibung bei MEHREREN Positionen": Produkt A blieb
// unveraendert, Produkt B wurde doppelt geschrieben). Hier laeuft die
// Verarbeitung sequenziell mit pro Position gebundenen Werten.
//
// WICHTIG (Routing-Freeze): " PRODSTOCK " ist ein Substring-Match des
// Master/Slave-Routings in CLS_CSQLite.js - SQL-Formen zeichengenau vom
// Original uebernommen.

function sql(query) {
  return Promise.resolve(POS.SQLiteCon.execute(query));
}

export const StockDomain = {
  // Offene Positionen eines Lieferschein-Bons.
  getDeliveryPositions(bonId) {
    return sql("SELECT Foreign_ID, Qty, WholesaleAmount FROM BONE WHERE BON_ID = " +
      bonId + " AND Type = 'POS' AND Cancelled = 0");
  },

  getStock(productId) {
    return sql("SELECT InStock, WholesaleAmount FROM PRODSTOCK " +
      "WHERE PROD_ID = " + productId)
      .then((rows) => (rows && rows.length ? rows[0] : null));
  },

  // Gleitender Einkaufspreis-Durchschnitt bei Wareneingang. Pure Funktion,
  // null = nicht neubewertbar (Bestand+Menge = 0; das Original erzeugte hier
  // NaN im UPDATE, das als SQL-Fehler still verschluckt wurde - jetzt wird
  // der Fall uebersprungen und geloggt, effektiv gleiches DB-Ergebnis).
  revalue(oldInStock, oldWholesaleAmount, quantity, wholesaleAmount) {
    const newInStock = oldInStock + quantity;
    if (newInStock === 0) return null;
    return {
      newInStock,
      newWholesaleAmount: ((oldInStock * oldWholesaleAmount) +
        (quantity * wholesaleAmount)) / newInStock,
    };
  },

  updateStock(productId, newInStock, newWholesaleAmount) {
    return sql("UPDATE PRODSTOCK SET InStock = " + newInStock + ", WholesaleAmount = " +
      newWholesaleAmount + ", Exported = 0 WHERE PROD_ID = " + productId);
  },

  // Kompletter Lieferschein: pro Position Bestand + EK-Durchschnitt
  // fortschreiben. Sequenziell, Werte pro Position gebunden.
  async applyDelivery(bonId) {
    const rows = await this.getDeliveryPositions(bonId);
    if (!rows) return;
    for (const row of rows) {
      const quantity = parseFloat(row.Qty);
      const productId = parseFloat(row.Foreign_ID);
      let wholesaleAmount = parseFloat(row.WholesaleAmount);
      if (!wholesaleAmount) wholesaleAmount = 0;

      const stock = await this.getStock(productId);
      if (!stock) continue; // Produkt ohne PRODSTOCK-Zeile: wie im Original ueberspringen

      const r = this.revalue(parseFloat(stock.InStock), parseFloat(stock.WholesaleAmount),
        quantity, wholesaleAmount);
      if (!r) {
        log.add(1, "Error", "StockDomain.applyDelivery",
          "Neubewertung uebersprungen (Bestand+Menge=0) fuer PROD_ID " + productId + ", Bon " + bonId);
        continue;
      }
      await this.updateStock(productId, r.newInStock, r.newWholesaleAmount);
    }
  },
};
